import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MetaGuard } from '@guards/meta-guards/meta-guard.service';
import { CanActivateUserLoginGuard } from '@guards/login/can-activate-user-login.guard';

//Environment
import { environment } from './../../../environments/environment';

// Components
import { LoginComponent } from './login/login.component';

const routes: Routes = [
    {
        path: '',
        canActivateChild: [MetaGuard],
        component: LoginComponent,
        data: {
            meta: {
                robots: environment.statusMetaIndexSpecific
            }
        },
        canActivate: [CanActivateUserLoginGuard]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class LoginTransversalRoutingModule { }